import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

const FormSelector = ({ blok, handleInputChange, formValue, dynamicData }) => {
  const blockWidths = {
    '25%': 'col-span-12 md:col-span-3',
    '33%': 'col-span-12 md:col-span-6 lg:col-span-4',
    '50%': 'w-full col-span-12 md:col-span-6',
    '66%': 'w-full col-span-12 md:col-span-6 lg:col-span-8',
    '75%': 'w-full col-span-12 md:col-span-9',
    '100%': 'w-full col-span-12',
  };

  const width =
    blok.width && blockWidths[blok.width]
      ? blockWidths[blok.width]
      : 'w-full col-span-12';

  return (
    (blok.dynamic_data && (
      <div className={`flex flex-col mb-6 ${width} px-4 md:px-8`}>
        {/* --- --->
        
        TODO: Add dynamic data to the selector
        
        >--- --- */}
        <label className="flex flex-col text-sm font-normal">
          {blok.label}
          <select
            value={formValue}
            onChange={(e) => {
              handleInputChange(e);
            }}
            className="form-select rounded py-1.5 text-base font-normal"
            name={blok.name}
          >
            {/* --- --->
          
          TODO: Do something with dynamic data, like {dynamicData.map((nestedBlok) => {... 

          >--- --- */}
          </select>
        </label>
      </div>
    )) || (
      <div
        className={`flex flex-col ${width} mb-6 px-4 md:px-8`}
        {...storyblokEditable(blok)}
      >
        <label className="flex flex-col">
          <span className="text-sm font-normal">
            {blok.label} {blok.label && blok.required ? '*' : ''}
          </span>
          <select
            value={formValue}
            onChange={(e) => {
              handleInputChange(e);
            }}
            className="form-select  rounded py-1.5 text-sm font-normal bg-yellow-25"
            name={blok.name}
          >
            {blok.options.map((nestedBlok) => {
              return (
                <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
              );
            })}
          </select>
        </label>
      </div>
    )
  );
};

export default FormSelector;
